import { Select } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
import { useUserGroup } from '../../hooks/user/usergroups'

const SettingGroup = ({ group, setGroup, style, defaultv = '0' }: any) => {
	const { type1 } = useUserGroup()

	return (
		<View
			style={{
				height: 45,
				width: '100%',
				borderBottom: '1px solid #ddd',
				padding: 3,
				...style,
			}}>
			<Select
				mode={'multiple'}
				defaultValue={defaultv}
				onChange={e => {
					//마지막게 defaultv이면 [defaultv]
					if (e[e.length - 1] === defaultv) {
						setGroup([defaultv])
					} else {
						e = e.filter((v: any) => v !== defaultv)
						setGroup(e)
						console.log(e)
					}

					//값이 없으면 defaultv
					if (e.length === 0) {
						setGroup([defaultv])
					}
				}}
				value={
					typeof group == 'string' ? group?.split(',') || [] : group
				}
				style={{ width: '100%', minWidth: 150 }}
				options={[
					{ value: defaultv, label: '그룹전체' },
					...(type1 || []),
				]}
			/>
		</View>
	)
}

export default SettingGroup
